import type NumberUnit from '@exodus/currency';
import { createSelector } from 'reselect';

import type { Assets } from '@/types/index.js';
import { balancesLoadedSelector } from './asset-balance.js';
import type { GetSpendableBalanceFn } from './get-spendable-balance.js';
import getSpendableBalanceSelector from './get-spendable-balance.js';
import selectors from '../../selectors.js';

type GetFeeAssetHasEnoughBalanceFn = (params: {
  assetName: string;
  walletAccount: string;
  fees: { fee: NumberUnit };
}) => boolean;

const getFeeAssetHasEnoughBalanceSelector = createSelector(
  selectors.availableAssets.all,
  balancesLoadedSelector,
  getSpendableBalanceSelector,
  (
    assets: Assets,
    balancesLoaded,
    getSpendableBalance: GetSpendableBalanceFn,
  ): GetFeeAssetHasEnoughBalanceFn =>
    ({ assetName, walletAccount, fees }) => {
      const asset = assets[assetName];
      if (!asset || !balancesLoaded) {
        return false;
      }

      const spendableBalance = getSpendableBalance({
        assetName: asset.feeAsset.name,
        walletAccount,
      });
      const fee = fees?.fee || asset.feeAsset.currency.ZERO;
      return spendableBalance.gte(fee);
    },
);

export default getFeeAssetHasEnoughBalanceSelector;
